// extracted by mini-css-extract-plugin
module.exports = {"styles":"styles___38cVb","img":"img___fiTNI","tip":"tip___2zVXT"};